<template>
  <NuxtLayout name="default">
    <div class="error-page">
      <div class="error-content">
        <img src="/images/image-in-error-page.svg" alt="404" class="error-icon" />

        <h1 class="error-title">
          {{ $t('error.pageNotFound.title') }}
        </h1>

        <p class="error-description">
          {{ $t('error.pageNotFound.description') }}
        </p>

        <PButton button-type="text" type="button" class="error-button" @on-click="goHome">
          {{ $t('error.pageNotFound.button') }}
        </PButton>
      </div>
    </div>
  </NuxtLayout>
</template>

<script setup lang="ts">
import { useRouter } from 'vue-router'

defineProps({
  error: {
    type: Object,
    default: () => ({}),
  },
})

const router = useRouter()

const goHome = () => {
  router.push('/')
}
</script>

<style scoped>
.error-page {
  justify-content: center;
  box-sizing: border-box;
  align-items: center;
  text-align: center;
  display: flex;
  padding: 2rem;
}

.error-content {
  max-width: 480px;
  width: 100%;
}

.error-icon {
  margin: 0 auto 48px;
  display: block;
  opacity: 0.7;
  width: 120px;
}

.error-title {
  margin-bottom: 16px;
  line-height: 60px;
  font-weight: 600;
  font-size: 48px;
  color: var(--fg-primary);
}

.error-description {
  color: var(--fg-secondary);
  margin-bottom: 16px;
  line-height: 22px;
  font-weight: 500;
  max-width: 450px;
  font-size: 16px;
}

.error-button {
  display: inline-flex;
  align-items: center;
  font-weight: 500;
  background: none;
  font-size: 14px;
  cursor: pointer;
  color: #6a9700;
  border: none;
  padding: 0;
  gap: 6px;
}

@media (max-width: 768px) {
  .error-title {
    line-height: 48px;
    font-size: 40px;
  }
}

.footer {
  padding-top: 0 !important;
  margin-top: -24px !important;
}
</style>
